// Where to send the user after a successful login from the global LoginModal.
//
// Cases (see LoginModal.handleLogin):
//  - `returnUrl` set → an API 401 captured the page the user was trying to
//    reach (fetcher.ts); send them back there (full nav).
//  - came from the password-reset flow → the modal was opened on the throwaway
//    `/user/password/reset` placeholder page, which is not somewhere to return
//    to; send them to their dashboard instead (SPA nav).
//  - came from the `/login` path → same shape: `/login` is a routing target,
//    not a real page with content underneath. Send them to their dashboard.
//  - otherwise → the user opened the modal themselves while browsing a real
//    page; stay put (the modal just closes and the page refreshes in place).
export type PostLoginDestination =
  | { kind: 'external'; url: string }
  | { kind: 'spa'; to: string }
  | { kind: 'stay' }

export function resolvePostLoginDestination(opts: {
  returnUrl: string | null
  cameFromReset: boolean
  cameFromLoginPath: boolean
  userId: number
}): PostLoginDestination {
  if (opts.returnUrl) return { kind: 'external', url: opts.returnUrl }
  if (opts.cameFromReset || opts.cameFromLoginPath) return { kind: 'spa', to: `/user/${opts.userId}` }
  return { kind: 'stay' }
}
